module.exports = __webpack_public_path__ + "static/media/information.ff916f41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/information.svg
// module id = 54
// module chunks = 0